export enum BadgesRoutesEnum {
    BADGES_LIST = 'badges'
}
